import { BaseUniDriver } from '@wix/wix-ui-test-utils/base-driver';
import { PaginationCoreUniDriver } from './PaginationCore/PaginationCore.uni.driver';

export { paginationCoreUniDriverFactory as paginationDriverFactory } from './PaginationCore/PaginationCore.uni.driver';

export interface PaginationUniDriver
  extends PaginationCoreUniDriver,
    BaseUniDriver {}
